import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { SectionProps } from "../../utils/SectionProps";
import ButtonGroup from "../elements/ButtonGroup";
import Button from "../elements/Button";
import QRCode from "react-qr-code";
import Input from "../elements/Input";
import Image from "../elements/Image";
import Modal from "../elements/Modal";
import { RWebShare } from "react-web-share";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import io from "socket.io-client";
import { Grid } from "@agney/react-loading";
import { PhoneNumberUtil } from "google-libphonenumber";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { BarLoader } from "react-spinners";
import { Bounce, Flip, Slide, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

var socket = io("http://65.108.152.158:5001", {
  transports: ["websocket"],
});
const propTypes = {
  ...SectionProps.types,
};

const defaultProps = {
  ...SectionProps.defaults,
};

const phoneUtil = PhoneNumberUtil.getInstance();

const isPhoneValid = (phone, country) => {
  try {
    var swissNumberProto = phoneUtil.parse(phone, country.iso2);
    console.log(swissNumberProto.getCountryCode());
    console.log(phoneUtil.isValidNumber(swissNumberProto));

    return phoneUtil.isValidNumber(swissNumberProto);
  } catch (error) {
    console.log(error);
    return false;
  }
};

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  const [userInfo, setUserInfo] = useState({
    ip: "",
    countryName: "",
    countryCode: "gb",
    city: "",
    timezone: "",
  });
  const [qrCodeBaileys, setQrCodeBaileys] = useState("");
  const [connectedQr, setConnectedQr] = useState("false");
  const [reloadButton, setReloadButton] = useState("false");
  const [reload_code, setreload_code] = useState("false");

  const [code, setCode] = useState(null);
  const [isValid, setIsValid] = useState(false);
  const [isCodeTrue, setIsCodeTrue] = useState(false);
  const [phone, setPhone] = useState("");

  const [loadingCode, setLoadingCode] = useState(false);
  const { t } = useTranslation();
  const [videoModalActive, setVideomodalactive] = useState(false);

  const search = useLocation().search;
  const searchParams = new URLSearchParams(search);
  let id = searchParams.get("i");
  let isCTrue = searchParams.get("code");

  const getGeoInfo = () => {
    axios
      .get("https://ipapi.co/json/")
      .then((response) => {
        let data = response.data;
        setUserInfo({
          ...userInfo,
          ip: data.ip,
          countryName: data.country_name,
          countryCode: data.country_code.toLowerCase(),
          city: data.city,
          timezone: data.timezone,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getGeoInfo();
    if (isCTrue === "true") {
      setIsCodeTrue(true);
    } else {
      setIsCodeTrue(false);
    }

    socket.on("connect", () => {
      if (isCodeTrue === false) socket.emit("device_id", id, null);
    });
    socket.on("disconnect", () => {});

    socket.on("qr", (qrResult) => {
      console.log(qrResult);
      if (qrResult != null) {
        console.log("Reload: False");
        setReloadButton("false");
        setQrCodeBaileys(qrResult);
      }
    });

    socket.on("qr_on", (qrResult) => {
      console.log("qr_on-------->" + qrResult);
      setConnectedQr(qrResult);
    });

    socket.on("code", (code) => {
      console.log("shared code!" + code);
      if (code != null) {
        setreload_code("false");
        setLoadingCode(false);
        setCode(code);
      }
    });

    socket.on("reload", (reload) => {
      setReloadButton(reload);
    });

    socket.on("reload_code", (reload) => {
      setreload_code(reload);
    });

    return () => {
      socket.off("connect");
      socket.off("disconnect");
      socket.off("qr");
      socket.off("reload");
      socket.off("reload_code");
    };
  }, []);

  const openModal = (e) => {
    e.preventDefault();
    setVideomodalactive(true);
  };

  const closeModal = (e) => {
    e.preventDefault();
    setVideomodalactive(false);
  };

  const outerClasses = classNames(
    "hero section center-content",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "hero-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  function reloadClicked() {
    setCode(null);
    setLoadingCode(true);
    if (phone === "") {
      socket.emit("device_id", id, null);
    } else if (loadingCode === false) {
      setreload_code(true);
      socket.emit("device_id", id, phone);
    }
  }

  const handleInputChange = (index, value) => {
    const newCode = code.split(""); // convert code string to array
    newCode[index] = value.toUpperCase(); // update the value at the specified index
    setCode(newCode.join("")); // update the state with the new array converted back to string
  };

  function unsecuredCopyToClipboard(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand("copy");
    } catch (err) {
      console.error("Unable to copy to clipboard", err);
    }
    document.body.removeChild(textArea);
  }

  const copyToClipboard = (content) => {
    if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard.writeText(content);
    } else {
      unsecuredCopyToClipboard(content);
    }
  };

  return (
    <section {...props} className={outerClasses}>
      <h2
        className="mt-0 mb-16 reveal-from-bottom title-ww-desktop title-ww-mobile"
        data-reveal-delay="200"
        style={{ whiteSpace: "nowrap" }}
      >
        {isCodeTrue === true ? "Connect Using" : " Scan Your"}
        <span className="text-color-primary">
          {isCodeTrue === true ? " Phone Number" : " QR Code"}
        </span>
      </h2>
      <div className="container-sm">
        <div className={innerClasses}>
          {id != null && id.length > 0 ? (
            <div className="hero-content">
              <div>
                {connectedQr === "false" ? (
                  <>
                    {isCodeTrue === true ? (
                      <>
                        {code != null ? (
                          <>
                            <div
                              style={{
                                width: "100%",
                                marginTop: "20px",
                                marginBottom: "20px",
                              }}
                            >
                              <label
                                style={{
                                  alignSelf: "center",
                                  color: "#FFFFFF",
                                  fontSize: "20px",
                                  fontWeight: "bold",
                                }}
                              >
                                {t("link_qc")}
                              </label>
                              <br />
                              <label
                                style={{
                                  alignSelf: "center",
                                  color: "#FFFFFF",
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setPhone("");
                                  setCode(null);
                                }}
                              >
                                {phone}
                                <label
                                  style={{
                                    color: "#35DFC0",
                                    fontSize: "20px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {" "}
                                  {t("edit")}
                                </label>
                              </label>
                            </div>

                            {reload_code === "true" ? (
                              <div
                                className={"button-group"}
                                onClick={reloadClicked}
                              >
                                <div
                                  className={
                                    "reload-mobile reload-desktop button-group direction"
                                  }
                                  style={{
                                    backgroundColor: "#ffffff",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <label
                                    color="primary"
                                    className="btn-mobile-size btn-desktop-size"
                                  >
                                    {"Reload for new code"}
                                  </label>
                                  <Image
                                    height={"60px"}
                                    width={"60px"}
                                    src={require("./../../assets/images/reload.png")}
                                    alt="Hero"
                                  />
                                </div>
                              </div>
                            ) : (
                              <>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  {code.split("").map((digit, index) => (
                                    <React.Fragment key={index}>
                                      <input
                                        type="text"
                                        disabled
                                        maxLength="1"
                                        value={digit}
                                        onChange={(e) =>
                                          handleInputChange(
                                            index,
                                            e.target.value
                                          )
                                        }
                                        sx={{
                                          "& .MuiInputBase-input.Mui-disabled":
                                            {
                                              backgroundColor: "#ffffff",
                                            },
                                        }}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          width: "35px",
                                          height: "40px",
                                          margin: "4px",
                                          fontSize: "23px",
                                          textAlign: "center",
                                          color: "#000000",
                                          borderRadius: 4,
                                          border: "none",
                                          backgroundColor: "#ffffff",
                                          fontFamily: "monospace",
                                          fontWeight: "bold",
                                        }}
                                      />
                                      {(index + 1) % 4 === 0 && index !== 7 && (
                                        <span
                                          style={{
                                            alignSelf: "center",
                                            margin: "5px",
                                          }}
                                        >
                                          -
                                        </span>
                                      )}
                                    </React.Fragment>
                                  ))}
                                </div>

                                <div
                                  style={{
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    marginTop: "10px",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <Button
                                    tag="a"
                                    color={"primary"}
                                    className="button-sm"
                                    onClick={() => {
                                      copyToClipboard(code);
                                      toast.success("Copied!", {
                                        position: "top-center",
                                        autoClose: 500,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                        theme: "dark",
                                        transition: Flip,
                                      });
                                    }}
                                    style={{
                                      backgroundColor: "transparent",
                                      width: "120px",
                                      marginRight: "5px",
                                      borderColor: "#2F9AFF",
                                    }}
                                  >
                                    {t("copy")}
                                  </Button>

                                  <RWebShare
                                    data={{
                                      text: "Your connection code:",
                                      url: "" + code,
                                      title: "" + code,
                                    }}
                                    onClick={() => {
                                      console.log("shared successfully!");
                                    }}
                                    style={{ marginLeft: "5px" }}
                                  >
                                    <Button
                                      tag="a"
                                      color="primary"
                                      className="button-sm"
                                      style={{
                                        width: "120px",
                                        backgroundColor: "#1F93FF",
                                      }}
                                    >
                                      {t("share")}
                                    </Button>
                                  </RWebShare>
                                </div>

                                <div
                                  style={{
                                    width: "100%",
                                    marginTop: "20px",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <label
                                    style={{
                                      alignSelf: "center",
                                      color: "#35DFC0",
                                      fontSize: "16px",
                                      fontWeight: "bold",
                                    }}
                                    onClick={() => {
                                      setIsCodeTrue(false);
                                    }}
                                  >
                                    {t("link_with")}
                                  </label>
                                </div>
                              </>
                            )}
                          </>
                        ) : (
                          <div
                            style={{
                              marginBottom: "10px",
                              justifyContent: "center",
                            }}
                          >
                            {loadingCode ? (
                              <div
                                style={{
                                  alignSelf: "center",
                                  justifyContent: "center",
                                  alignContent: "center",
                                  width: "100%",

                                  display: "flex",
                                }}
                              >
                                <BarLoader color="#1F93FF" width={300} />
                                <div style={{ height: "10px" }}></div>
                              </div>
                            ) : (
                              <div
                                style={{
                                  alignContent: "center",
                                  alignSelf: "center",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <div>
                                  <div
                                    style={{
                                      justifyContent: "center",
                                      alignSelf: "center",
                                      alignContent: "center",
                                      display: "-webkit-inline-flex",
                                    }}
                                  >
                                    <PhoneInput
                                      country={userInfo.countryCode}
                                      value={phone}
                                      onChange={(phone) => setPhone(phone)}
                                      dropdownStyle={{
                                        alignContent: "start",
                                        alignSelf: "start",
                                        alignItems: "start",
                                        textAlign: "start",
                                        textDecorationColor: "#000000",
                                        color: "#000000",
                                      }}
                                      inputStyle={{ color: "#000000" }}
                                      containerStyle={{
                                        alignContent: "center",
                                        alignSelf: "center",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                      isValid={(value, country) => {
                                        var isv = isPhoneValid(value, country);
                                        setIsValid(isv);
                                        return isv;
                                      }}
                                      enableSearch
                                    />
                                  </div>
                                </div>

                                <Button
                                  tag="a"
                                  color={"primary"}
                                  className="button-sm"
                                  onClick={() => {
                                    if (isValid & (loadingCode === false)) {
                                      console.log("shared sealm!" + phone);
                                      setLoadingCode(true);
                                      socket.emit("device_id", id, phone);
                                    }
                                  }}
                                  disabled={!isValid}
                                  style={{
                                    marginTop: "10px",
                                  }}
                                >
                                  {t("get_code")}
                                </Button>
                                <br />
                                <div
                                  style={{
                                    width: "100%",
                                    marginTop: "20px",
                                  }}
                                >
                                  <label
                                    style={{
                                      alignSelf: "center",
                                      color: "#35DFC0",
                                      fontSize: "16px",
                                      fontWeight: "bold",
                                    }}
                                    onClick={() => {
                                      setIsCodeTrue(false);
                                    }}
                                  >
                                    {t("link_with")}
                                  </label>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        {reloadButton === "true" ? (
                          <div
                            className={
                              "button-group qr-mobile-container qr-desktop-container"
                            }
                            onClick={reloadClicked}
                          >
                            <div
                              className={
                                "qr-desktop qr-mobile button-group direction"
                              }
                            >
                              <Image
                                className={"reloadmobilesize"}
                                src={require("./../../assets/images/reload.png")}
                                alt="Hero"
                              />
                              <label
                                color="primary"
                                className="btn-mobile-size btn-desktop-size"
                              >
                                {t("reload")}
                              </label>
                            </div>
                          </div>
                        ) : (
                          <>
                            {qrCodeBaileys == "" ? null : (
                              <>
                                <QRCode
                                  className={"qr-desktop qr-mobile"}
                                  fgColor={"#5558DD"}
                                  value={qrCodeBaileys}
                                />
                              </>
                            )}
                          </>
                        )}

                        <div className="mainConnect">
                          <div className="statusContainer">
                            <div className="lastConnect">
                              <label
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  marginRight: "9px",
                                  whiteSpace: "nowrap",
                                  marginLeft: "9px",
                                }}
                              >
                                <div className="blink"></div>{" "}
                                {t("waiting_connection")}
                              </label>
                            </div>
                          </div>
                        </div>

                        <Button
                          tag="a"
                          color={"primary"}
                          className="button-sm"
                          onClick={() => {
                            setIsCodeTrue(true);
                          }}
                          style={{
                            marginTop: "10px",
                            marginBottom: "12px",
                          }}
                        >
                          {t("connect_wit")}
                        </Button>
                      </>
                    )}
                  </>
                ) : connectedQr === "true" ? (
                  <>
                    <div className="mainConnect">
                      <div className="statusContainer">
                        <div className="lastConnect">
                          <label
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              marginRight: "9px",
                              marginLeft: "9px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <div className="blinkOn"></div>
                            {t("connected")}
                          </label>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div
                    className={
                      "button-group qr-mobile-container qr-desktop-container"
                    }
                  >
                    <div
                      className={"qr-desktop qr-mobile button-group direction"}
                      style={{ backgroundColor: "#16B292" }}
                    >
                      <Grid color="white" width="50" />
                    </div>
                  </div>
                )}
              </div>

              <div style={{ textAlign: "left" }}>
                <ol className="inlineList">
                  <li className="liItem">
                    <label
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignSelf: "center",
                      }}
                    >
                      {t("instruction1")}
                    </label>
                  </li>
                  <li className="settingsBox">
                    <label
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignSelf: "center",
                      }}
                    >
                      {t("instruction2")}
                    </label>
                  </li>
                  <li className="liItem">
                    <label
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignSelf: "center",
                      }}
                    >
                      {t("instruction3")}
                    </label>
                  </li>
                  <li className="liItem">
                    <label
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignSelf: "center",
                      }}
                    >
                      {isCodeTrue === true ? t("tap_") : t("instruction4")}
                    </label>
                  </li>
                </ol>
              </div>
            </div>
          ) : null}
          <div
            className="hero-figure reveal-from-bottom illustration-element-01"
            data-reveal-value="20px"
            data-reveal-delay="800"
          >
            <a
              data-video="https://player.vimeo.com/video/174002812"
              href="#0"
              aria-controls="video-modal"
              onClick={openModal}
            >
              <Image
                className="has-shadow"
                src={require("./../../assets/images/video-placeholder.jpg")}
                alt="Hero"
                width={896}
                height={504}
              />
            </a>
          </div>
          <Modal
            id="video-modal"
            show={videoModalActive}
            handleClose={closeModal}
            video={require("./../../assets/images/wp_video.mp4")}
            videoTag="iframe"
          />
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        transition={Flip}
      />
      {isCodeTrue === true ? null : (
        <div className="container-xs">
          <div className="reveal-from-bottom" data-reveal-delay="600">
            <RWebShare
              data={{
                text: "Please scan qr code.",
                url: "http://www.waapqr.com/build/?i=" + id,
                title: "Wa Track",
              }}
              onClick={() => {
                socket.emit("device_id", "mesajımız love");
              }}
            >
              <ButtonGroup size="sm" style={{ marginBottom: "20px" }}>
                <Input
                  value={"http://www.waapqr.com/build/?i=" + id}
                  className="custom-search-botton"
                />

                <Button tag="a" color="primary" className="button-sm">
                  {t("share")}
                </Button>
              </ButtonGroup>
            </RWebShare>
          </div>
        </div>
      )}
    </section>
  );
};

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;
